// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-details .detail-toggle {
  border: none;
  color: var(--color-interaction-text);
  display: inline-block;
  width: 100%;
}
.item-details .detail-toggle .fa-angle-down {
  font-weight: 600;
}
.item-details .detail-toggle .fa-angle-right {
  font-weight: 600;
}
.item-details .detail-toggle .details {
  font-weight: 600;
  padding-left: 5%;
}
.item-details .detail-info {
  margin-top: 20px;
}
.item-details .detail-info .text-label {
  font-weight: 600;
}
.item-details .detail-info div {
  margin-top: 2%;
}
.item-details .detail-info .text-lable,
.item-details .detail-info .text-value {
  display: inline-block;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/shared/components/order-details/item-info-display/item-info-display.component.scss"],"names":[],"mappings":"AAEE;EACE,YAAA;EACA,oCAAA;EACA,qBAAA;EACA,WAAA;AADJ;AAEI;EACE,gBAAA;AAAN;AAEI;EACE,gBAAA;AAAN;AAEI;EACE,gBAAA;EACA,gBAAA;AAAN;AAGE;EACE,gBAAA;AADJ;AAEI;EACE,gBAAA;AAAN;AAEI;EACE,cAAA;AAAN;AAEI;;EAEE,qBAAA;EACA,WAAA;AAAN","sourcesContent":[".item-details {\n  //  margin-top: 7%;\n  .detail-toggle {\n    border: none;\n    color: var(--color-interaction-text);\n    display: inline-block;\n    width: 100%;\n    .fa-angle-down {\n      font-weight: 600;\n    }\n    .fa-angle-right {\n      font-weight: 600;\n    }\n    .details {\n      font-weight: 600;\n      padding-left: 5%;\n    }\n  }\n  .detail-info {\n    margin-top: 20px;\n    .text-label {\n      font-weight: 600;\n    }\n    div {\n      margin-top: 2%;\n    }\n    .text-lable,\n    .text-value {\n      display: inline-block;\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
